<template>
  <FileComponent v-model="value" multiple :readonly="true" />
</template>

<script>
import { FileComponent } from '@kvass/file'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    FileComponent,
  },
}
</script>

<style lang="scss"></style>
